module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C118_14"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C124_15"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface_#page_vii"
    }
  }, [_vm._v("Preface, W. J. T. Mitchell")])])]), _vm._v(" "), _c('p', {
    staticClass: "C118_3a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_I__M_SO#page_3"
    }
  }, [_vm._v("I’M SO ANGRY I MADE A SIGN")])]), _vm._v(" "), _c('p', {
    staticClass: "C125"
  }, [_vm._v("Michael Taussig")]), _vm._v(" "), _c('p', {
    staticClass: "C118_3a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_POLITICA#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POLITICAL DISOBEDIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "C125"
  }, [_vm._v("Bernard E. Harcourt")]), _vm._v(" "), _c('p', {
    staticClass: "C118_16"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_IMAGE__S#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IMAGE, SPACE, REVOLUTION")]), _vm._v(" "), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_IMAGE__S#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arts of Occupation")])])]), _vm._v(" "), _c('p', {
    staticClass: "C125"
  }, [_vm._v("W. J. T. Mitchell")]), _vm._v(" "), _c('p', {
    staticClass: "C118_16"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Note",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0